<app-master-detail-layout
    [isMobile]="isMobile"
    [showDetail]="showDetailMobile"
    (backToSidebar)="goBack()"
>
    
    <span sidebarTitle #sidebarTitle>{{'FIDELITY.SETUP.PRIZES.TITLE' | translate}}</span>

    <div sidebarActions #sidebarActions>
        <button mat-icon-button
            (click)="addPrize()"
        >
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <div sidebar>
        @for(prize of prizesList; track prize.id; let i = $index) {
            <app-sidebar-item
                [isSelected]="isSelected(prize)"
                (click)="selectPrize($event, i)"
            >
                <span title #title>{{ prize.name }}</span>
            </app-sidebar-item>
        }
    </div>

    <div headerTitle class="tw-w-full tw-min-w-0">
        @if(isNotEmptyState) { 
            <span class="tw-w-full" [appTruncatedText]="prizeFormService.name?.value || ''"
            >{{prizeFormService.name?.value || ('FIDELITY.SETUP.PRIZES.PLACEHOLDER_NAME' | translate)}}</span>
        }
    </div>

    <ng-container actions>
        @if(isNotEmptyState) {
            @if(selectedPrize?.id) {
                <app-action-btn variant="basic"
                    (click)="deletePrize()"
                >
                Elimina
                </app-action-btn>
            }
    
            <app-action-btn 
                [disabled]="!prizeForm.valid"
                (click)="savePrize()"
            >
            Salva
            </app-action-btn>
        }
    </ng-container>

    <ng-container content>
        @if(isNotEmptyState) {
            <app-card [fullWidth]="true" [withCard]="false">
                <form autocomplete="off" [formGroup]="prizeForm"
                        class="form tw-flex tw-flex-col tw-gap-5">
                    <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
                
                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-4">
                            <mat-label translate>FIDELITY.SETUP.PRIZES.NAME</mat-label>
                            <input matInput formControlName="name" appTrimInput>
                            <mat-hint [align]="'end'">{{prizeFormService.name?.value?.length || '0'}}
                                / {{prizeFormService.validators.nameMaxLength}}</mat-hint>
                            @if(prizeFormService.name?.hasError('maxlength')) {
                                <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{prizeFormService.validators.nameMaxLength}})</mat-error>
                            } @else if(prizeFormService.name?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-4 md:tw-col-span-6">
                            <mat-label translate>FIDELITY.SETUP.PRIZES.POINTS</mat-label>
                            <input matInput type="number" formControlName="points"
                                [min]="0">
                            @if(prizeFormService.points?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>
                
                        <mat-form-field class="tw-col-span-12 lg:tw-col-span-4 md:tw-col-span-6">
                            <mat-label translate>FIDELITY.SETUP.PRIZES.TYPE</mat-label>
                            <mat-select formControlName="type">
                                @for(prize of prizeTypes; track prize.value) {
                                    <mat-option [value]="prize.value">{{prize.name}}</mat-option>
                                }
                            </mat-select>
                            @if(prizeFormService.type?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>

                        @if(prizeFormService.type?.value === 'gift') {
                            <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                                <mat-label translate>FIDELITY.SETUP.PRIZES.ITEM</mat-label>
                                <input matInput formControlName="item_name" appTrimInput readonly
                                    (click)="editItem()"
                                >
                                @if(prizeFormService.item_sku?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        } @else {
                            <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                                <mat-label translate>FIDELITY.SETUP.PRIZES.DISCOUNT_AMOUNT</mat-label>
                                <input matInput type="number" formControlName="discount_amount"
                                    [min]="0">
                                @if(prizeFormService.discount_amount?.hasError('min') || prizeFormService.discount_amount?.hasError('max')) {
                                    <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                                } @else if(prizeFormService.discount_amount?.hasError('required')) {
                                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                                }
                            </mat-form-field>
                        }

                        <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                            <mat-label translate>FIDELITY.SETUP.PRIZES.CAMPAIGN</mat-label>
                            <mat-select formControlName="campaign_id">
                                @for(campaign of campaignsList; track campaign.id) {
                                    <mat-option [value]="campaign.id">{{campaign.name}}</mat-option>
                                }
                            </mat-select>
                            @if(prizeFormService.campaign_id?.hasError('required')) {
                                <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                            }
                        </mat-form-field>

                        <!-- <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                            <mat-label>{{ "FIDELITY.SETUP.PRIZES.VALID_FROM" | translate }}</mat-label>
                            <input matInput [matDatepicker]="picker_from" formControlName="valid_from">
                            <mat-datepicker-toggle matIconSuffix [for]="picker_from"></mat-datepicker-toggle>
                            <mat-datepicker #picker_from></mat-datepicker>
                        </mat-form-field>
    
                        <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                            <mat-label>{{ "FIDELITY.SETUP.PRIZES.VALID_TO" | translate }}</mat-label>
                            <input matInput [matDatepicker]="picker_to" formControlName="valid_to">
                            <mat-datepicker-toggle matIconSuffix [for]="picker_to"></mat-datepicker-toggle>
                            <mat-datepicker #picker_to></mat-datepicker>
                        </mat-form-field> -->

                        <div class="tw-col-span-12 md:tw-col-span-6">
                            <tilby-datetime-picker formControlName="valid_from"
                                label="FIDELITY.SETUP.PRIZES.VALID_FROM" />
                        </div>

                        <div class="tw-col-span-12 md:tw-col-span-6">
                            <tilby-datetime-picker formControlName="valid_to" label="FIDELITY.SETUP.PRIZES.VALID_TO" />
                        </div>
                        
                    </section>
                </form>
            </app-card>
        } @else {
            <ng-container *ngTemplateOutlet="emptyState"></ng-container>
        }
    </ng-container>
</app-master-detail-layout>

<ng-template #emptyState>
    <section class="lg:tw-col-span-2 tw-col-span-1 tw-h-full tw-block">
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-flex-1 tw-text-center">
            <div class="tw-bg-slate-50 tw-rounded-full tw-p-2 tw-text-slate-400">
                <mat-icon class="!tw-w-24 !tw-h-24 tw-text-[96px]">ads_click</mat-icon>
            </div>
            <h3 class="tw-font-semibold tw-text-slate-500 tw-max-w-md">
                {{ 'FIDELITY.SETUP.PRIZES.PRIZE_NOT_SELECTED_MSG' | translate }}
            </h3>
        </div>
    </section>
</ng-template>